import Quill from 'quill';

// const BlockEmbed = Quill.import('blots/block/embed');
const BlockEmbed = Quill.import('blots/inline');

class CustomErrorBlot extends BlockEmbed {
  static create(attrs) {
    const { value, isInsert } = attrs;
    const node = super.create(value);
    isInsert && (node.innerText = value);
    node.contentEditable = 'true';
    return node;
  }

  static formats(node) {
    return {
      value: node.innerText,
    };
  }
}

CustomErrorBlot.blotName = 'CustomErrorEmbed';
CustomErrorBlot.className = 'ql-custom-embed';
CustomErrorBlot.tagName = 'span';

export default CustomErrorBlot;
